import { render, staticRenderFns } from "./TranslationEditForm.vue?vue&type=template&id=93fd501c&scoped=true"
import script from "./TranslationEditForm.vue?vue&type=script&lang=js"
export * from "./TranslationEditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93fd501c",
  null
  
)

export default component.exports